__turbopack_context__.v({
  "chart": "HistogramChart-module__XcK9Mq__chart",
  "results": "HistogramChart-module__XcK9Mq__results",
  "resultsLabel": "HistogramChart-module__XcK9Mq__resultsLabel",
});
